import { useGoTo } from 'vuetify';

export default function usePageScroll(options = {}) {
  const goTo = useGoTo();

  const questionElements = ref({});
  const goToOptions = {
    container: options?.container || 'html',
    duration: options?.duration || 300,
    easing: options?.easing || 'easeInOutCubic',
    offset: options?.offset || -25,
  };

  async function goToElement(index) {
    if (index && questionElements.value[index]) {
      await goTo(questionElements.value[index], goToOptions);
    }
  }

  async function goToElementByQuery(query) {
    if (query) {
      await goTo(query, goToOptions);
    }
  }

  function setElement(element, index) {
    questionElements.value[index] = element;
  }

  return { goToElement, goToElementByQuery, setElement };
}
